import React from 'react';
import styled from 'styled-components';
import CommonSection from '../../components/commonSection/CommonSection';
import card from '../../../assets/card-apply/icons/alert-circle.svg';
import SectionTitle from '../../components/sectionTitle/SectionTitle';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SErrorPage = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  padding: ${theme.spacing.large}px 0;
  @media only screen and ${theme.device.laptopS} {
    padding: ${theme.spacing.huge}px 0;
  }
`
);

const SColumn = styled.section(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.large}px;
  text-align:center;
  @media only screen and ${theme.device.laptopS} {
    flex: 1 0;
    margin-bottom: ${theme.spacing.huge}px;
    & + & {
      margin-right: ${theme.spacing.larger}px;
    }
  }
`
);

const SCardImage = styled.img`
  max-width: 100%;
  margin-bottom: 41px;
`;

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IErrorPageProps {
  errorDescription: string | ((props?: any) => string);
}

// tslint:disable-next-line:variable-name
const ErrorPage: React.FC<IErrorPageProps> = (props) => {
  const displayTxt = typeof props.errorDescription === 'function' ? props.errorDescription() : props.errorDescription;

  return (
    <SErrorPage data-dd-privacy={PrivacyOptions.Allow}>
      <SColumn>
        <SCardImage src={card} />
        <CommonSection>
          <SectionTitle data-at="errorDescription" dangerouslySetInnerHTML={{ __html: displayTxt }} />
        </CommonSection>
      </SColumn>
    </SErrorPage>
  );
};

export default ErrorPage;
